/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NdcUnit } from './ndcUnit';
import { UpdateProcedureDiagnosisCodeHoldingViewModel } from './updateProcedureDiagnosisCodeHoldingViewModel';

export interface UpdateProcedureTransactionHoldingViewModel {
  id?: string;
  datasetId?: string;
  sendingFacilityId?: string;
  patientHoldingId?: string | null;
  patientId?: string | null;
  visitHoldingId?: string | null;
  procedureId?: string | null;
  attendingProviderId?: string | null;
  referringProviderId?: string | null;
  orderingProviderId?: string | null;
  primaryProviderId?: string | null;
  supervisingProviderId?: string | null;
  fromDate?: string | null;
  toDate?: string | null;
  placeOfServiceCodeId?: string | null;
  locationId?: string | null;
  modifier1Id?: string | null;
  modifier2Id?: string | null;
  modifier3Id?: string | null;
  modifier4Id?: string | null;
  financialClassId?: string | null;
  procedureAmount?: number | null;
  quantity?: number;
  accessionNumber?: string | null;
  insuranceAuthNumber?: string | null;
  comment?: string | null;
  nationalDrugCodeId?: string | null;
  drugUnit?: NdcUnit;
  drugQuantity?: number | null;
  drugAmount?: number | null;
  drugCode?: string | null;
  prescriptionNumber?: string | null;
  holdPatientBilling?: boolean | null;
  holdInsuranceBilling?: boolean | null;
  nocProcedureDescription?: string | null;
  isChargeCentralApproved?: boolean;
  isDeleted?: boolean;
  deletedBy?: string | null;
  deletedDate?: string | null;
  createdBy?: string | null;
  createdDate?: string;
  updatedBy?: string | null;
  claimComment?: string | null;
  updatedDate?: string | null;
  primaryInsuranceAuthNumber?: string | null;
  secondaryInsuranceAuthNumber?: string | null;
  tertiaryInsuranceAuthNumber?: string | null;
  externalId?: string | null;
  diagnoses?: Array<UpdateProcedureDiagnosisCodeHoldingViewModel> | null;
}
